module.exports = "<div class=\"content-wrapper\">\r\n    <ejs-pdfviewer id=\"pdfViewer\" [serviceUrl]='serviceURL' [documentPath]='fileName' [toolbarSettings]= 'toolbarSettings'  style=\"height:640px;display:block\"></ejs-pdfviewer>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/pdf.control.html
// module id = ../../../../../client/app/shared/controls/pdf.control.html
// module chunks = main